import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import type { ImportFeilRad } from '@/services/api/types';

const feilTekst = (f: ImportFeilRad): string => {
  if (f.radnr === undefined) return f.melding;
  return f.kolonne ? `Rad ${f.radnr} (${f.kolonne}): ${f.melding}` : `Rad ${f.radnr}: ${f.melding}`;
};

/** Feil fra server eller validering. Alltid vist som tekst. */
const ImportFeilListe: React.FC<{ feil: ImportFeilRad[] }> = ({ feil }) => (
  <Alert variant="destructive" role="alert">
    <AlertDescription>
      <ul className="list-disc space-y-1 pl-5 max-h-48 overflow-y-auto">
        {feil.map((f, i) => (
          <li key={i}>{feilTekst(f)}</li>
        ))}
      </ul>
    </AlertDescription>
  </Alert>
);

export default ImportFeilListe;
